export default __webpack_public_path__ + "static/Food-2958ea5d55cd75390a48fa3a29613723.png";